import { UIErrorType } from "@superblocksteam/shared";

import { uiLogger } from "core/telemetry/logger";
import type { UIEvent } from "core/utils/event";

/*
The replacer parameter allows you to specify a function that replaces values with your own. We can use it to control what gets stringified.
*/
function replaceError(key: string, value: any) {
  if (value instanceof Error) {
    const newValue = Object.getOwnPropertyNames(value).reduce(
      (obj, propName) => {
        obj[propName] = (value as any)[propName];
        return obj;
      },
      { name: value.name } as any,
    );
    return newValue;
  } else {
    return value;
  }
}

export const stringifyError = (error: any) => {
  return JSON.stringify(error, replaceError, 2);
};

export const getUIErrorTypeByCode = (code: number) => {
  let errorType = UIErrorType.SERVER_ERROR_OTHER;
  if (code >= 500) {
    errorType = UIErrorType.SERVER_ERROR_5XX;
  } else if (code >= 400) {
    errorType = UIErrorType.SERVER_ERROR_4XX;
  }
  return errorType;
};
class Logger {
  private static _instance: Logger;

  private constructor() {}

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  debug(message: any, messageContext = {}, sendToOtel = true): void {
    if (!sendToOtel) {
      console.debug(message);
      return;
    }
    const msg = typeof message === "object" ? JSON.stringify(message) : message;
    uiLogger.debug(msg, messageContext);
  }

  info(message: any, messageContext = {}): void {
    const msg = typeof message === "object" ? JSON.stringify(message) : message;
    uiLogger.info(msg, messageContext);
  }

  warn(message: any, messageContext = {}): void {
    const msg = typeof message === "object" ? JSON.stringify(message) : message;
    uiLogger.warn(msg, messageContext);
  }

  error(message: any, messageContext = {}): void {
    const msg = typeof message === "object" ? JSON.stringify(message) : message;
    uiLogger.error(msg, messageContext);
  }

  /**
   * @deprecated TODO: (@joeyagreco) configure this to use the same flow as the CloudEventSender in the server
   */
  event(type: UIEvent, properties = {}): void {
    console.debug("skipping sending event");
  }

  setUIDiagnosticContext(context: Record<string, unknown>) {
    uiLogger.setUIDiagnosticContext(context);
  }

  getUIDiagnosticContext() {
    return uiLogger.getUIDiagnosticContext();
  }
}

export default Logger.Instance;
